import React from 'react';

export const TimeBufferItem = ({ buffer }) => {
  return (
    <li className="timeline-item active timeline-item--no-icon">
      <div className="timeline-item-label col-12 mb-2 bg-warning">
        <p className="tx-07 lp mb-0 lh-1-3rem opa-05">{__('routes.time_buffer')}</p>

        <p className="tx-11 text-bold-700 mb-1 lh-1-3rem">{buffer}</p>
      </div>
    </li>
  );
};
